import { Builder } from '@builder.io/react';

// eslint-disable-next-line import/no-named-as-default
import Footer from './index';

Builder.registerComponent(Footer, {
  name: 'Footer',
  inputs: [
    {
      name: 'border',
      type: 'boolean'
    },
    {
      name: 'theme',
      type: 'string',
      enum: ['dark', 'light'],
      defaultValue: 'dark'
    }
  ]
});
